import type { DragEventHandler } from 'react'
import { ArrowDown, ArrowUp, GripVertical } from 'lucide-react'

interface ExchangeChartOrderControlsProps {
  exchange: string
  canMoveUp: boolean
  canMoveDown: boolean
  onMoveUp: () => void
  onMoveDown: () => void
  onDragStart: DragEventHandler<HTMLButtonElement>
  onDragEnd: DragEventHandler<HTMLButtonElement>
}

const buttonClass = 'pointer-events-auto flex h-5 w-5 items-center justify-center rounded text-slate-500 hover:bg-slate-800 hover:text-slate-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-300 disabled:cursor-default disabled:opacity-25 disabled:hover:bg-transparent'

export function ExchangeChartOrderControls({
  exchange, canMoveUp, canMoveDown, onMoveUp, onMoveDown, onDragStart, onDragEnd,
}: ExchangeChartOrderControlsProps) {
  return (
    <div className="flex shrink-0 items-center" role="group" aria-label={`Reorder ${exchange} chart`}>
      <button type="button" draggable onDragStart={onDragStart} onDragEnd={onDragEnd}
        className={`${buttonClass} cursor-grab active:cursor-grabbing`}
        title={`Drag to move ${exchange} chart, or use the up/down buttons`}
        aria-label={`Drag ${exchange} chart to reorder`}>
        <GripVertical className="h-3.5 w-3.5" />
      </button>
      <button type="button" disabled={!canMoveUp} onClick={onMoveUp} className={buttonClass}
        title={`Move ${exchange} chart up`} aria-label={`Move ${exchange} chart up`}>
        <ArrowUp className="h-3 w-3" />
      </button>
      <button type="button" disabled={!canMoveDown} onClick={onMoveDown} className={buttonClass}
        title={`Move ${exchange} chart down`} aria-label={`Move ${exchange} chart down`}>
        <ArrowDown className="h-3 w-3" />
      </button>
    </div>
  )
}
